export default __webpack_public_path__ + "static/media/masthead.f857d83e.jpg";